import Constants from '../../../utils/CommonConstants';
import module from '../module';
import * as _ from 'lodash';
import { utils } from "../../../utils/shopifyInjector/utils";

export const connectionStateString = [
    'connecting',
    'connected',
    'reconnecting',
    '',
    'disconnected'
];

export const connectionState = {
    connecting: 0,
    connected: 1,
    reconnecting: 2,
    disconnected: 4
};

export class RealTimeUpdateService {
    static $inject = ['cartonomyConfig', 'Session', '$rootScope', 'Hub'];

    constructor(cartonomyConfig, sessionService, rootScope, Hub) {
        this._hubService = Hub;
        this._sessionService = sessionService;
        this._rootScope = rootScope;
        this._cartonomyConfig = cartonomyConfig;
        this.hubOptions = null;
        this.retriesResetConnection = 0;
        this.intentionallyDisconnected = false;

        let signalrServerRoot = this._cartonomyConfig.backendEndPoint.trim('/') + '/signalr';

        this.hubConfiguration = {
            listeners: {
                onCartUpdated: () => this._onCartUpdated(),
                onCartCheckedOut: () => this._onCartCheckedOut(),
                onCartItemsUpdated: (cartUpdate) => this._onCartItemsUpdated(cartUpdate),
                onChatMessageReceived: (messageObj) => this._onChatMessageReceived(messageObj),
                onCartCancelledByOwner: (messageObj) => this._onCartCancelledByOwner(),
                onCartClearedByOwner: (messageObj) => this._onCartClearedByOwner(),
                onRemovedByOwner: (messageObj) => this._onRemovedByOwner(),
                onCartOwnershipTransfererred: (messageObj) => this._onCartOwnershipTransferred(messageObj),
                onSwitchedCart: (messageObj) => this._onSwitchedCart(messageObj),
            },
            serverMethods: ['createMessage'],
            rootPath: signalrServerRoot,
            onError: (error) => this._onHubError(error),

            errorHandler: async(error) => {
                this.resetConnection();
            },

            stateChanged: async(state) => {
                if (state.newState === connectionState.disconnected && !this.intentionallyDisconnected) {
                    setTimeout(() => {
                        this.retriesResetConnection++;
                        if (this.retriesResetConnection === 50 && navigator.onLine) {
                            //ping to check internet
                            fetch(`${utils.cartonomyApiUrl}v2/version/ping`)
                            .then((response) => {
                                if(response.status === 200){
                                    window.location.reload();
                                }
                            })
                            .catch((error) => {
                                console.log(error);
                            });
                        }else if(this.retriesResetConnection > 50){
                            this.retriesResetConnection = 0;
                        }
                        this.resetConnection();
                    }, 2000);
                }

                if (state.newState === connectionState.connected) {
                    this._rootScope.$broadcast(Constants.Events.SIGNALR_CONNECTED);
                    setTimeout(() => {
                        this.retriesResetConnection = 0;
                    }, 5000);
                }
            }
        };

        rootScope.$on(Constants.Events.USER_LOGGED_OUT, (scope) => {
            this.disconnect(true);
            this.reset();
        });
    }

    async _onHubError(error) {
        console.error(error);
        this.resetConnection();
    }

    disconnect(intentionally) {
        this.intentionallyDisconnected = !!intentionally;
        try {
            this.instance && this.instance.disconnect();
        } catch (e) {

        } finally {
            this.instance = null;
        }
    }

    resetConnection() {
        this.disconnect();
        this._createHub(this.hubOptions);
    }

    async ensureConnected() {
        if (this.instance)
            return;

        await this._connect();
    }

    async _connect() {
        this.hubOptions = _.cloneDeep(this.hubConfiguration);

        this.hubOptions.queryParams = {
            Authorization: 'Bearer ' + await this._sessionService.getAuthToken(),
            X_EXTERNAL_STORE: this._cartonomyConfig.externalStoreUrl
        };

        this.intentionallyDisconnected = false;
        this._createHub();

        await this.instance.connect().done();
    }

    _createHub() {
        this.instance = new this._hubService('clientGroupCartHub', this.hubOptions);
    }

    reset() {
        this._postList = [];
    }

    _onCartUpdated() {
        this._sessionService.setCartReference(null);
    }

    _onSwitchedCart(cartInfo) {
        this._rootScope.$broadcast(Constants.Events.USER_JOINED_OTHER_CART, cartInfo);
    }

    _onCartClearedByOwner(){
        this._rootScope.$broadcast(Constants.Events.ORDER_CLEARED_BY_OWNER);
    }

    _onCartCancelledByOwner() {
        this._rootScope.$broadcast(Constants.Events.ORDER_CANCELLED_BY_OWNER);
    }

    _onRemovedByOwner() {
        this._rootScope.$broadcast(Constants.Events.USER_REMOVED_BY_OWNER);
    }

    _onCartCheckedOut() {
        this._rootScope.$broadcast(Constants.Events.ORDER_CHECKED_OUT);
    }

    _onChatMessageReceived(messageObj) {
        this._rootScope.$broadcast(Constants.Events.REALTIME_CHAT_RECEIVED, messageObj);
    }

    _onCartOwnershipTransferred(messageObj) {
        new Audio(Constants.Notifications.newCartItemNotification).play();
        this._rootScope.$broadcast(Constants.Events.CART_OWNERSHIP_TRANSFERRED, messageObj);
    }

    _onCartItemsUpdated(cartUpdate) {
        if (!cartUpdate.isOwner) {
            new Audio(Constants.Notifications.newCartItemNotification).play();
        }

        this._rootScope.$broadcast(Constants.Events.CART_ITEMS_CHANGED, cartUpdate);
        this._sessionService.setCartReference(null);
        this._rootScope.$broadcast(Constants.BroadcastMessages.POPUP_BAG_CHANGED);
    }
}

module.service('RealTimeUpdateService', RealTimeUpdateService);



// WEBPACK FOOTER //
// ./src/modules/shared/services/RealTimeUpdateService.js